import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import "./NavbarComponent.css"

const NavbarComponent = () => {
  return (
    <Navbar bg="light" expand="lg"> 
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto">
          <Nav.Link as={Link} to="/about"> About </Nav.Link>
          <Nav.Link as={Link} to="/education">Education</Nav.Link>
          <Nav.Link as={Link} to="/publications">Publications</Nav.Link>
          <Nav.Link as={Link} to="/awards">Awards</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavbarComponent;